export const getCellContent = (rowData, col) => {
    if (col.cell) {
        return col.cell(rowData)
    } else if (col.subProperty) {
        return rowData[col.property][col.subProperty]
    } else return rowData[col.property]
}
